export default function PremiumServices() {
  const premiumServices = [
    {
      name: 'Clothes Steam Press',
      price: 35,
      image: 'https://public.readdy.ai/ai/img_res/75da0a537e2323e1c10451714f162e41.jpg',
      icon: 'ri-iron-line'
    },
    {
      name: 'Clothes Dry Cleaning',
      price: 95,
      image: 'https://readdy.ai/api/search-image?query=Premium%20dry%20cleaning%20service%20with%20elegant%20formal%20garments%20on%20professional%20hangers%2C%20business%20suits%20and%20delicate%20clothing%2C%20modern%20laundry%20facility%20interior%2C%20soft%20professional%20lighting%2C%20high-end%20clothing%20care%20service%2C%20clean%20white%20background&width=120&height=120&seq=premium-002&orientation=squarish',
      icon: 'ri-handbag-line'
    },
    {
      name: 'Saree Steam Press',
      price: 90,
      image: 'https://readdy.ai/api/search-image?query=Colorful%20traditional%20Indian%20sarees%20with%20vibrant%20patterns%20in%20red%20pink%20green%20gold%20colors%2C%20elegant%20silk%20fabrics%20neatly%20arranged%2C%20professional%20saree%20steam%20pressing%20service%2C%20clean%20white%20background%2C%20commercial%20photography%20showing%20rich%20textile%20details%20and%20intricate%20embroidery%20work&width=120&height=120&seq=premium-003&orientation=squarish',
      icon: 'ri-layout-row-line'
    },
    {
      name: 'Saree Role Press',
      price: 90,
      image: 'https://readdy.ai/api/search-image?query=Traditional%20Indian%20sarees%20professionally%20rolled%20and%20organized%20in%20vibrant%20colors%20including%20red%20green%20blue%20gold%2C%20elegant%20silk%20fabric%20rolls%2C%20premium%20saree%20care%20service%2C%20clean%20white%20background%2C%20commercial%20photography%20highlighting%20rich%20textile%20patterns%20and%20professional%20organization&width=120&height=120&seq=premium-004&orientation=squarish',
      icon: 'ri-layout-column-line'
    }
  ];

  return (
    <section id="premium-services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-sm font-medium text-amber-600 border border-amber-600/30 px-5 py-2 rounded-full inline-block mb-4">
            Bulk Orders Only
          </span>
          <h2 className="text-5xl font-bold text-gray-900 mb-4">Premium Service Price</h2>
          <p className="text-lg text-gray-600">Large quantity orders for premium garment care</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {premiumServices.map((service, index) => (
            <div
              key={index}
              className="group bg-gradient-to-br from-amber-50 to-white rounded-2xl p-6 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer border border-amber-100"
            >
              <div className="relative w-24 h-24 mx-auto mb-4 rounded-xl overflow-hidden">
                <img
                  src={service.image}
                  alt={service.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              
              <div className="text-center">
                <h3 className="text-xl font-bold text-gray-900 mb-3">{service.name}</h3>
                <div className="flex items-baseline justify-center gap-1 mb-4">
                  <span className="text-3xl font-bold text-amber-600">₹{service.price}</span>
                  <span className="text-sm text-gray-500">.00</span>
                </div>
                
                <div className="pt-4 border-t border-amber-100">
                  <div className="flex items-center justify-center gap-2">
                    <span className="text-sm text-gray-500">Per item</span>
                    <div className="w-8 h-8 flex items-center justify-center bg-amber-100 rounded-lg group-hover:bg-amber-600 transition-colors">
                      <i className={`${service.icon} text-amber-600 group-hover:text-white text-lg transition-colors`}></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-2 bg-amber-100 px-6 py-3 rounded-full">
            <i className="ri-star-line text-amber-600 text-xl"></i>
            <p className="text-sm text-gray-700">
              <span className="font-semibold">Bulk Orders Only:</span> Specialized care for large quantity orders - Contact us for requirements
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
